import { Observable } from 'rxjs';
import { LandLineProcedureInterface } from '../models/land-line-procedure.interface';
import { ApiService } from '../../shared/services/api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LandLineProcedureService {

  constructor(private apiService: ApiService) {
  }

  /**
   * Get procedures list
   */
  get(landline: string): Observable<Array<LandLineProcedureInterface>> {
    return this.apiService.post('landline/procedures/list', {landline});
  }
}

